import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import { api, type PaginationResponse } from '@/api';
import type { NotificationItem, UnreadCountResponse } from '@/features/notifications/types';

export const notificationsQuery = (isRead?: boolean) =>
  infiniteQueryOptions({
    queryKey: isRead === undefined ? ['notifications'] : ['notifications', { isRead }],
    queryFn: async ({ pageParam }) =>
      (
        await api.get<PaginationResponse<NotificationItem>>('v1/notifications', {
          params: { page: pageParam, pageSize: 20, isRead },
        })
      ).data,
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) =>
      allPages.length < lastPage.pageCount ? allPages.length + 1 : undefined,
    staleTime: 10 * 1000,
    refetchOnWindowFocus: true,
  });

export const unreadCountQuery = () =>
  queryOptions({
    queryKey: ['notificationsUnreadCount'],
    queryFn: async () => (await api.get<UnreadCountResponse>('v1/notifications/unread-count')).data,
    staleTime: 10 * 1000,
    refetchOnWindowFocus: true,
  });
